import { useEffect } from 'react';
import {
  StoreProvider,
  RouterProvider,
  ErrorBoundaryProvider,
  AuthInitializer,
  AntdThemeProvider,
} from './providers';
import { initMetrika } from '@shared/lib';

export function App() {
  // Инициализация вне роутера, чтобы счётчик встал до первой навигации.
  // При пустом YANDEX_METRIKA_ID — no-op (см. metrika.ts).
  useEffect(() => {
    initMetrika();
  }, []);

  return (
    <ErrorBoundaryProvider>
      <StoreProvider>
        <AntdThemeProvider>
          <AuthInitializer>
            <RouterProvider />
          </AuthInitializer>
        </AntdThemeProvider>
      </StoreProvider>
    </ErrorBoundaryProvider>
  );
}
